import React from "react";
import { MetricGrid, PageIntro, SectionCard, StatusList } from "../../components/goldbot/GoldBotCards";
import { useGoldBotStatusValue } from "../../components/goldbot/GoldBotStatusProvider";
import {
  applyOverviewRequestState,
  buildLiveOverviewData,
  buildUnavailableOverviewData,
} from "../../components/goldbot/goldBotStatusViewModel";

function GoldBotOverview() {
  const { data, error, isLoading } = useGoldBotStatusValue();
  // No mock fallback: an unreachable API must never render account values.
  const overviewData =
    data && !error ? buildLiveOverviewData(data) : buildUnavailableOverviewData();
  const systemStatus = applyOverviewRequestState(overviewData.systemStatus, {
    error,
    isLoading,
  });

  return (
    <>
      <PageIntro eyebrow="Command dashboard" title="Overview" description="System health, account exposure, and live trading activity at a glance." />
      <div className="goldbot-grid goldbot-grid--top">
        <SectionCard title="System Status" eyebrow="Infrastructure">
          <StatusList items={systemStatus} />
        </SectionCard>
        <SectionCard title="Trading" eyebrow="Live activity">
          <MetricGrid items={overviewData.tradingMetrics} className="goldbot-metric-grid--trading" />
        </SectionCard>
      </div>
      <SectionCard title="Account" eyebrow="MT5 account overview">
        <MetricGrid items={overviewData.accountMetrics} />
      </SectionCard>
    </>
  );
}

export default GoldBotOverview;
